import { useParams } from 'react-router-dom';

import { useCarePlanService } from '@/shared/guard';
import { ReportLink } from '@/shared/model';

function checkForValidOrganInLinks(links: ReportLink[], organKey: string): boolean {
  return links.some(
    (item) => item.key === organKey || (item.sub && checkForValidOrganInLinks(item.sub, organKey)),
  );
}

export function useRouteValidation() {
  const { organ } = useParams<{ organ: string }>();

  const { links } = useCarePlanService();

  return links && organ ? checkForValidOrganInLinks(links, organ.replace(/-/g, '_')) : true;
}
